<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div><div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div class="w-full" 
                v-if="role === 'SuperAdministrador' && form.idDistribuidor">
                <div class="flex justify-between items-center">
                  <div class="w-full">
                    <AccessibleElSelect
                      v-model="form.idDistribuidor"
                      prop="idDistribuidor"
                      :options="distribuidoresForAccessibleSelect"
                      :withFormItem="true"
                      :isDisabled="true"
                      id-prefix="user"
                    >
                      <template slot="label">{{$t('distributors.distributor')}}</template>
                    </AccessibleElSelect>
                  </div>
                  <base-button class="ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailDistributor" :loading="isGeneralLoading"/>
                </div>
              </div>

              <div class="w-full" 
                v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador') &&
                 (form.roleId !== 5 && form.roleId !== 6)">
                <div class="flex justify-between items-center">
                  <div class="w-full">
                    <AccessibleElSelect
                      v-model="form.clienteId"
                      prop="clienteId"
                      :options="clientesForAccessibleSelect"
                      :withFormItem="true"
                      :isDisabled="true"
                      id-prefix="user"
                    >
                      <template slot="label">{{$t('app.client')}}</template>
                    </AccessibleElSelect>
                  </div>
                  <base-button class="ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
                </div>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.username')}}
                  <el-form-item prop="name">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      v-model="form.name"
                      maxlength='50'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.email')}}
                  <el-form-item prop="email">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      v-model="form.email"
                      maxlength='255'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.roleId"
                prop="roleId"
                :options="rolesForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="true"
                id-prefix="user"
              >
                <template slot="label">{{$t('configurations.rol')}}</template>
              </AccessibleElSelect>
            </div>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.tipoAuth"
                prop="tipoAuth"
                :options="tiposAuthForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="true"
                id-prefix="user"
              >
                <template slot="label">{{$t('configurations.tipo_auth')}}</template>
              </AccessibleElSelect>
            </div>
            <div class="mb-2 lg:mb-4">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="ver-todo-statuses-user-switch" class="sr-only">
                    {{$t('configurations.ver_todo_statuses')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="ver-todo-statuses-user-switch"
                    :aria-label="$t('configurations.ver_todo_statuses')"
                    class="switch-text break-normal" 
                    disabled 
                    v-model="form.verTodoStatuses" 
                    :active-text="$t('configurations.ver_todo_statuses')"/>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="ver-todo-companies-user-switch" class="sr-only">
                    {{$t('configurations.ver_todo_companies')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="ver-todo-companies-user-switch"
                    :aria-label="$t('configurations.ver_todo_companies')"
                    class="switch-text break-normal" 
                    disabled 
                    v-model="form.verTodoCompanies" 
                    :active-text="$t('configurations.ver_todo_companies')"/>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>

            <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="activo-user-switch" class="sr-only">
                    {{$t('app.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="activo-user-switch"
                    :aria-label="$t('app.active')"
                    class="switch-text break-normal" 
                    disabled
                    v-model="form.Activo" 
                    :active-text="$t('app.active')"/>
                </div>
              </div>
            </div>

            <div class="mb-2 lg:mb-6" v-if="hasModuleDobleFactor && form.tipoAuth !== 1 && this.form.tipoAuth !== 3">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="mb-4 lg:mb-0 w-full">
                  <label for="doble-factor-user-switch" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('configurations.client_config_otp')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  </label>
                  <el-switch 
                    id="doble-factor-user-switch"
                    :aria-label="$t('configurations.client_config_otp')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.DobleFactor"
                    disabled
                    :active-text="$t('app.active')"/>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="trash"
            @click="deleteUser()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="restore"
            @click="restoreUser()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <BaseElDialog
        title="Borrar usuario"
        :visible.sync="showModal"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-user')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteUser }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-user">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </BaseElDialog>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getClients } from '@/services/clients/getClients'
import { getUser } from '@/services/configurations/getUser'
import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'
import { ROLES } from '@/config/roles'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { deleteTrashUser } from '@/services/trash/deleteTrashUser'
import { restoreTrashUser } from '@/services/trash/restoreTrashUser'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import { getDistributors } from '@/services/distributors/getDistributors'

import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-usuario',
  components: {
    DetailLayout,
    BaseElDialog,
    AccessibleElSelect
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: 'DETALLE DE USUARIO BORRADO',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'trash/users'
      },
      form: this.getDefaultForm(),
      distribuidores: [],
      clientes: [],
      tiposAuth: TIPOS_AUTH,
      tooltipVerTodoStatuses: this.$i18n.t('tooltip.ver_todo_statuses'),
      tooltipVerTodoCompanies: this.$i18n.t('tooltip.ver_todo_companies'),
      toolAccesoAAD: this.$i18n.t('tooltip.acceso_AAD'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      showModal: false,
      processMessageDeleteUser: '¿Estás seguro que deseas borrar permanente el usuario?',
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    roles: function () {
      return ROLES.filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    getIdUsuarioLogged: function () {
      return this.$store.getters['auth/user'].IdUsuario
    },
    isSameUser: function () {
      return this.getIdUsuarioLogged === this.id
    },
    hasModuleDobleFactor () {
      return this.$store.getters['auth/hasModuleDobleFactor']
    },
    distribuidoresForAccessibleSelect () {
      return this.distribuidores.map(dist => ({
        id: dist.IdDistribuidor,
        name: dist.Nombre,
        value: dist.IdDistribuidor
      }))
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        name: cliente.Nombre,
        value: cliente.IdEmpresa
      }))
    },
    rolesForAccessibleSelect () {
      return this.roles.map(role => ({
        id: role.id,
        name: role.name,
        value: role.id
      }))
    },
    tiposAuthForAccessibleSelect () {
      return this.tiposAuth.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id
      }))
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const localUser = this.$store.getters['auth/user']
    this.localUserId = localUser.IdUsuario
    const breadcrumbs = []
    
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    }

    await this.downloadData(this.id)
    breadcrumbs.push({ path: 'trash/users', name: this.$i18n.t('app.trash') })
    breadcrumbs.push({ path: 'trash/users', name: this.$i18n.t('trash.users') })
    breadcrumbs.push({ path: '', name: this.form.name })
    this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    goDetailDistributor () {
      const id = this.form.idDistribuidor
      this.$router.push({ name: 'configurations/distributors/details', params: { id } })
    },
    deleteUser () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: []
        }
        payload.idsUsuario.push(this.id)
        const response = await deleteTrashUser(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreUser: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: []
        }
        payload.idsUsuario.push(this.id)
        const response = await restoreTrashUser(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        Activo: false,
        company: '',
        active: false,
        idDistribuidor: null,
        created_at: '',
        password: '',
        repeat_password: '',
        clienteId: null,
        roleId: null,
        verTodoStatuses: false,
        verTodoCompanies: false,
        tipoAuth: null,
      }
    },
    watchFormHandler: function ({
      certificate,
      send_alerts,
      automatic_download
    }) {},
    toggleDialogs: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    goBack: function () {
      this.$router.push({ name: 'trash/users' })
    },
    downloadData: async function (id) {
      let user = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idUsuario: id,
          borrado: true,
        }
        user = await getUser(params)
        this.setUser(user.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return user
    },
    setUser: function (user) {
      const role = this.roles.find(r => r.name === user.Rol)
      this.form.id = user.IdUsuario
      this.form.name = user.Usuario
      this.form.email = user.Email
      this.form.company = user.Empresa
      this.form.active = user.active
      this.form.created_at = user.created_at
      this.form.roleId = role ? role.id : null
      this.form.clienteId = user.idEmpresa
      this.form.verTodoStatuses = user.VerTodoEstados
      this.form.verTodoCompanies = user.VerTodoEmpresas
      this.form.DobleFactor = user.DobleFactor
      this.form.Activo = user.Activo
      this.form.tipoAuth = user.idTipoAutenticacion
      this.form.idDistribuidor = user.idDistribuidor
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
